import { render } from "./ButtonMain.vue?vue&type=template&id=24c40ad8&scoped=true"
import script from "./ButtonMain.vue?vue&type=script&lang=js"
export * from "./ButtonMain.vue?vue&type=script&lang=js"

import "./ButtonMain.vue?vue&type=style&index=0&id=24c40ad8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c40ad8"]])

export default __exports__